export default "__VITE_ASSET__CjxmMeWl__"